import { z } from "zod";
import { ValidationError } from "../errors/ValidationError";
import { dispatchValidationError } from "../errors/errorDispatcher";

const vendorIdSchema = z
  .union([z.number().int(), z.array(z.number().int())])
  .transform((v) => (Array.isArray(v) ? v : [v]))
  .refine((arr) => arr.length > 0, { message: "vendorId must be a non-empty array" });

const optionalNonEmptyString = z.preprocess((value) => {
  if (value == null) {
    return undefined;
  }
  if (typeof value !== "string") {
    return value;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}, z.string().optional());

export const productsSearchRequestSchema = z.object({
  isFromVendor: z.literal(true).default(true),
  limit: z.number().int().positive().max(100).optional(),
  page: z.number().int().min(0).optional().default(0),
  vendorId: vendorIdSchema,
  ordine: z
    .enum(["asc", "desc", "ASC", "DESC"])
    .optional()
    .default("asc")
    .transform((s) => (s.toLowerCase() === "desc" ? "DESC" : "ASC")),
  nomeColonna: z.string().optional(),
  ricerca: optionalNonEmptyString,
  ruolo: z.enum(["vendor", "user"]).optional().default("vendor"),
  prezzoMin: z.number().finite().optional(),
  prezzoMax: z.number().finite().optional(),
  soloDisattivati: z.boolean().optional(),
  soloEliminati: z.boolean().optional(),
}).superRefine((payload, ctx) => {
  if (payload.soloDisattivati && payload.soloEliminati) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "soloDisattivati and soloEliminati are mutually exclusive",
    });
  }
});

export function validateProductsSearchRequest(data) {
  const parsed = productsSearchRequestSchema.safeParse(data);
  if (!parsed.success) {
    const message = `Invalid productsSearch payload: ${parsed.error.message}`;
    dispatchValidationError({ message, issues: parsed.error.issues, raw: parsed.error });
    throw new ValidationError(message, { issues: parsed.error.issues, raw: parsed.error });
  }
  return parsed.data;
}

